// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/app/v1/app_refs.proto" (package "c1.api.app.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementRef
 */
export interface AppEntitlementRef {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string id = 2;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementUserBindingRef
 */
export interface AppEntitlementUserBindingRef {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 2;
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: string app_user_id = 3;
     */
    appUserId: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementRef$Type extends MessageType<AppEntitlementRef> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementRef", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementRef
 */
export const AppEntitlementRef = new AppEntitlementRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementUserBindingRef$Type extends MessageType<AppEntitlementUserBindingRef> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementUserBindingRef", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementUserBindingRef
 */
export const AppEntitlementUserBindingRef = new AppEntitlementUserBindingRef$Type();
